module.exports = __webpack_public_path__ + "static/media/14UNEP8.fdfb50c9.jpg";